import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-operation',
  templateUrl: './card-operation.component.html',
  styleUrls: ['./card-operation.component.css']
})
export class CardOperationComponent implements OnInit {

  @Input() operation: string;
  constructor() { }

  ngOnInit() { }

}
